import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
//import { vuetifyTheme } from "./plugins/vuetify";
import SocketIO from "vue-socket.io-extended";
import io from "socket.io-client";
import ErrorMessage from "@/components/Widgets/ErrorMessage";
import VueCountdownTimer from "vuejs-countdown-timer";
import { VueCsvImportPlugin } from "./plugins/vue-csv-import";

Vue.prototype.$appVersion = process.env.VUE_APP_VERSION;
Vue.prototype.$appTitle = process.env.VUE_APP_TITLE;

Vue.component("error-message", ErrorMessage);
//Vue.use(vuetifyTheme);
Vue.use(VueCountdownTimer);
Vue.use(VueCsvImportPlugin);

Vue.config.productionTip = false;

const socket = io(
  process.env.VUE_APP_SOCKET_URI + "/" + store.state.namespace,
  {
    path: process.env.VUE_APP_SOCKET_PATH,
    autoConnect: false,
    transports: ["websocket"]
  }
);

console.log("IN NAMESPACE: ", store.state.namespace);

Vue.use(SocketIO, socket, { store });

new Vue({
  router,
  store,
  //vuetifyTheme,
  vuetify,
  render: (h) => h(App)
}).$mount("#app");
